import React from "react";
import styled, { css } from "styled-components";

import { ReactComponent as SearchIcon } from "../../assets/icons/searchIcon.svg";

const PlainSearchInput = ({
    setSearchString,
    searchString,
    placeholder,
    width = "480px",
    showBoxShadow = false,
}) => {
    const handleSearchInput = (e) => {
        const { value } = e.target;
        setSearchString(value);
    };
    return (
        <SearchInputStyled width={width} showBoxShadowStyle={showBoxShadow}>
            <div>
                <SearchIcon />
            </div>
            <input placeholder={placeholder} value={searchString} onChange={handleSearchInput} />
        </SearchInputStyled>
    );
};

export const SearchInputStyled = styled.div`
    width: ${({ width }) => width};
    max-width: 100%;
    height: 48px;
    border-radius: 10px;
    border: 1px solid #dbdce0;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;

    ${({ showBoxShadowStyle }) =>
        showBoxShadowStyle &&
        css`
            border: 1px solid #f4f4f4;
            box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
        `}
    input {
        border: none;
        width: 100%;
        height: 100%;
        outline: none;
        font-weight: normal;
        font-size: 0.938rem;
        line-height: 16px;
        color: var(--primaryColor);
        border-radius: 5px;

        ::placeholder {
            color: #979797;
            font-size: 0.938rem;
        }
    }
`;

export default PlainSearchInput;
